export default __webpack_public_path__ + "static/media/closing-theme.8a3563bf.mp3";